import gql from "graphql-tag"

export const MEDIA_FOLDERS = gql`
  query mediaFolders($siteId: Int!) {
    mediaFolders(siteId: $siteId) {
      id
      name
      siteId
      createdAt
      updatedAt
    }
  }
`